// extracted by mini-css-extract-plugin
export default {"container":"Splash_container__fFltt","logo":"Splash_logo__VaQgx","pulse":"Splash_pulse__5Ab8S"};